export const FormLabel = {
  baseStyle: {
    mb: '1.5',
    fontSize: 'xs',
    color: 'gamma.200',
    fontWeight: '600',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
